// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2-13T","noInteraction":"EventWrapper_noInteraction__gVeeM","pointerPassthrough":"EventWrapper_pointerPassthrough__1Txgt"};